import { API } from '../Api';

// Lịch sử đồng ý điều khoản (admin) — cab-user-service /v1/user-service/admin/Consent/history (gateway gate Admin/Mod).
export interface ConsentRecord {
  id: string;
  userId: string;
  policyKey: string;
  version: string;
  acceptedAt: string;
  ip?: string | null;
}
export interface ConsentHistoryResult {
  total: number;
  pageNumber: number;
  pageSize: number;
  items: ConsentRecord[];
}

export const getConsentHistory = (
  policyKey?: string,
  pageNumber = 1,
  pageSize = 100
): Promise<ConsentHistoryResult> => {
  const params = new URLSearchParams({ pageNumber: String(pageNumber), pageSize: String(pageSize) });
  if (policyKey) params.set('policyKey', policyKey);
  return API.get(`/v1/user-service/admin/Consent/history?${params.toString()}`).then(
    (r) => r.data?.data ?? r.data
  );
};
